import React from 'react';
import { COLORS, TOP_INDENTS } from '@constants';
import { Button, Typography } from '@ui';
import { Col, Row } from 'antd';
import { StyledList } from './styled';

const HowToFindMeasurementId = ({ close }) => {
    return (
        <Row justify='center'>
            <Col span={16} justify='center' align='center'>
                <video
                    width='400'
                    controls
                    muted
                    data-e2e='tracking_ga-measurement-id-modal_video'
                    style={{ marginBottom: '16px' }}
                >
                    <source src='https://cdn.klickly.com/boa_videos/ga4.mp4' type='video/mp4' />
                    Your browser does not support the video tag.
                </video>
                <StyledList data-e2e='tracking_ga-measurement-id-modal-steps_list'>
                    <li>
                        <Typography.Text type='body2'>
                            <b>Navigate to Admin:</b> Open your Google Analytics 4 dashboard and click the Admin gear
                            icon in the bottom left corner.
                        </Typography.Text>
                    </li>
                    <li>
                        <Typography.Text type='body2'>
                            <b>Open Data Streams:</b> In the second column (Property), click on Data Streams and then
                            select your active web data stream.
                        </Typography.Text>
                    </li>
                    <li>
                        <Typography.Text type='body2'>
                            <b>Copy the ID:</b> Locate your Measurement ID at the top right (it will always start with
                            &quot;G-&quot;, e.g., G-12345ABCDE). Copy this ID and paste it into Klickly.
                        </Typography.Text>
                    </li>
                </StyledList>
                <Button
                    data-e2e='tracking_ga-measurement-id-modal-close_btn'
                    backgroundColor={COLORS.$white}
                    padding='0 58px'
                    justify='center'
                    style={TOP_INDENTS.XL_PLUS}
                    onClick={close}
                >
                    Close
                </Button>
            </Col>
        </Row>
    );
};

export default HowToFindMeasurementId;
